import Vue from 'vue'
import axios from 'axios';
import signMd5Utils from '@/utils/encryption/signMd5Utils'


// const API_BASE_URL = 'http://192.168.0.101:8081/nbcio-boot'
const API_BASE_URL = 'https://www.cnmspoep.com.cn/nbcio-boot'
// const STATIC_API_BASE_URL = 'http://121.37.110.170:8080/nbcio-boot/sys/common/static'
const STATIC_API_BASE_URL = 'http://121.42.246.119:8380/nbcio-boot/sys/common/static'
// 'http://mistgc.top:8082';
//普通用户登录
export const login = (username, password) => {
  return axios.post(`${API_BASE_URL}/api/v1/student/login`, {
    username,
    password,
  }).then(response => {
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || '登录失败');
    }
  }).catch(error => {
    console.error('登录请求失败:', error);
    throw error;
  });
};

//管理员登录
export const adminLogin = (username, password) => {
  return axios.post(`${API_BASE_URL}/api/v1/manager/login`, {
    username,
    password,
  }).then(response => {
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || '管理员登录失败');
    }
  }).catch(error => {
    console.error('管理员登录请求失败:', error);
    throw error;
  });
};
//超级管理员登录
export const superAdminLogin = (username, password) => {
  return axios.post(`${API_BASE_URL}/api/v1/admin/login`, {
    username,
    password,
  }).then(response => {
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || '管理员登录失败');
    }
  }).catch(error => {
    console.error('管理员登录请求失败:', error);
    throw error;
  });
};

//首页图书信息
export const fetchBooks = () => {
  return axios.get(`${API_BASE_URL}/api/v1/learning_material/list`);
};

//书本图片
export const fetchCoverImage = (cover_image_id) => {
  return axios.get(`${API_BASE_URL}/api/v1/cover_img/content?id=${cover_image_id}`, {
    responseType: 'blob' // 指定响应类型为 blob
  });
};

//学院信息
export const fetchColleges = () => {
  return axios.get(`${API_BASE_URL}/api/v1/college/list`).then(response => {
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || '获取学院列表失败');
    }
  });
};

//获取学期
export const fetchSemesters = () => {
  return axios.get(`${API_BASE_URL}/api/v1/semester/list`).then(response => {
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || '获取学期列表失败');
    }
  });
};

//班级信息
export const fetchClasses = (grade, collegeId) => {
  return axios.get(`${API_BASE_URL}/api/v1/class/list`, {
    params: { grade, college_id: collegeId }
  }).then(response => {
    if (response.data.code === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || '获取班级列表失败');
    }
  });
};

//学生注册信息创建
export const registerUser = (userData) => {
  return axios.post(`${API_BASE_URL}/api/v1/student/create`, userData, {
    headers: { 'Content-Type': 'application/json' }
  }).then(response => {
    if (response.data.code === 201) {
      return response.data;
    } else {
      throw new Error(response.data.message || '注册失败');
    }
  });
};



//获取国家政策
export const getPolicyList = (paramsInfo) => {
  // , {params: paramsInfo}
  return axios.get(`${API_BASE_URL}/sysindexdatamanage/tbIndexPolicyStandards/list`, {params: paramsInfo}).then(response => {
    console.log('response-------------------------',response);
    if (response.status === 200) {
      return response.data.result.records;
    } else {
      throw new Error('获取国家政策列表失败');
    }
  });
};

//获取评价标准
export const getStandardList = (paramsInfo) => {
  return axios.get(`${API_BASE_URL}/sysindexdatamanage/tbIndexPolicyStandards/list`, {params: paramsInfo}).then(response => {
    console.log('response-------------------------',response);
    if (response.status === 200) {
      return response.data.result.records;
    } else {
      throw new Error('获取评价标准列表失败');
    }
  });
};

// pdf获取数据流
// let sign = signMd5Utils.getSign(url, parameter);
//将签名和时间戳，添加在请求接口 Header
// let signHeader = {"X-Sign": sign,"X-TIMESTAMP": signMd5Utils.getDateTimeToString()};

export const getPdfAction1 = (parameter) => {
  let sign = signMd5Utils.getSign('${API_BASE_URL}/api/origionResource/getPdfStream', {filePath: parameter});
  //将签名和时间戳，添加在请求接口 Header
  let signHeader = {"X-Sign": sign,"X-TIMESTAMP": signMd5Utils.getDateTimeToString()};
  return axios.get(`${API_BASE_URL}/api/origionResource/getPdfStream`, {
    params: {filePath: parameter},
    Headers: signHeader,
    responseType: 'blob' // 指定响应类型为 blob
  });
};

export const getPdfAction = (parameter) => {
  // let sign = signMd5Utils.getSign('${API_BASE_URL}/api/origionResource/getPdfStream', {filePath: parameter});
  // console.log('sing-----------------------',sign);
  //将签名和时间戳，添加在请求接口 Header
  // let signHeader = {"X-Sign": sign,"X-TIMESTAMP": signMd5Utils.getDateTimeToString()};
  // console.log('signHeader-----------------------',signHeader);
  return axios.get(`${API_BASE_URL}/api/origionResource/getPdfStream`, {
    params: {filePath: '/'+parameter},
    // Headers: signHeader,
    responseType: 'blob' // 指定响应类型为 blob
  }).then(response => {
    if (response.status === 200) {
      console.log('-------------------------');
      console.log('response========',response);
      console.log('response.data========',response.data);
      return response.data;
    } else {
      throw new Error('获取评价标准列表失败');
    }
  });
};


//查询成果检索数据
export const getProjectList = (paramsInfo) => {
  console.log("paramsInfo........................",paramsInfo);
  return axios.get(`${API_BASE_URL}/patentmanage/tbPatentInfo/list`, {
    params: paramsInfo
  }).then(response => {
    console.log('response-------------------------',response);
    if (response.status === 200) {
      return response;
    } else {
      throw new Error('获取评价标准列表失败');
    }
  });
};


//查询成果检索详细数据
export const getProjectById = (id) => {
  return axios.get(`${API_BASE_URL}/patentmanage/tbPatentInfo/queryById?id=${id}`).then(response => {
    console.log('responsegetProjectById-------------------------',response);
    if (response.status === 200) {
      return response.data.result;
    } else {
      throw new Error('获取评价标准列表失败');
    }
  });
};

// 科技查新提交申请
export const submitDataIndexSearchNew = (data) => {
  console.log('data-------------------',data);
  return axios.post(`${API_BASE_URL}/sysindexdatamanage/tbIndexSearchNew/add`, data).then(response => {
    console.log('response------------------',response)
    if (response.data.code === 200) {
      // ElMessage.success("查询成功");
      return response.data;
    } else {
      throw new Error(response.data.message || '注册失败');
    }
  });
};

// 查询专家列表
export const getExportList = (paramsInfo) => {
  return axios.get(`${API_BASE_URL}/sysindexdatamanage/tbIndexExpert/list`, {
    params: paramsInfo
  }).then(response => {
    if (response.status === 200) {
      return response.data.result.records;
    } else {
      throw new Error('获取评价标准列表失败');
    }
  });
};


/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrl(avatar,subStr) {
  if(!subStr) subStr = 'http'
  try {
    if(avatar && avatar.startsWith(subStr)){
      return avatar;
    }else{
      if(avatar &&　avatar.length>0 && avatar.indexOf('[')==-1){
        return STATIC_API_BASE_URL + "/" + avatar;
      }
    }
  }catch(err){
   return;
  }
}

//获取专家领域信息
export const getFieldList = () => {
  return axios.get(`${API_BASE_URL}/sysindexdatamanage/tbIndexAchievements/getResearchFieldData`).then(response => {
    console.log('response-------------------------',response);
    if (response.status === 200) {
      return response.data.result;
    } else {
      throw new Error('获取列表失败');
    }
  });
};

//获取专家详细信息
export const exportDetail = (id) => {
  return axios.get(`${API_BASE_URL}/sysindexdatamanage/tbIndexExpert/queryById?id=${id}`).then(response => {
    console.log('response-------------------------',response);
    if (response.status === 200) {
      return response.data.result;
    } else {
      throw new Error('获取列表失败');
    }
  });
};

// 首页---行业动态
export const getContextList = (paramsInfo) => {
  return axios.get(`${API_BASE_URL}/sysindexdatamanage/tbIndexContent/list`, {
    params: paramsInfo
  }).then(response => {
    if (response.status === 200) {
      return response.data.result.records;
    } else {
      throw new Error('获取评价标准列表失败');
    }
  });
};



//获取首页详细信息
export const contextDetail = (id) => {
  return axios.get(`${API_BASE_URL}/sysindexdatamanage/tbIndexContent/queryById?id=${id}`).then(response => {
    console.log('response-------------------------',response);
    if (response.status === 200) {
      return response.data.result;
    } else {
      throw new Error('获取列表失败');
    }
  });
};


// 成果检索---成果类别
export const getTypeList = (pcode) => {
  return axios.get(`${API_BASE_URL}/sysindexdatamanage/tbIndexContent/queryCategoryList`).then(response => {
    // console.log('response--------------------------',response);
    if (response.status === 200) {
      return response.data.result;
    } else {
      throw new Error('获取评价标准列表失败');
    }
  });
};

// 成果检索---研发机构表
export const getTbResearchInstitutionsList = (pcode) => {
  return axios.get(`${API_BASE_URL}/researchinstitutions/tbResearchInstitutions/getList`).then(response => {
     console.log('response--------------------------',response);
    if (response.status === 200) {
      return response.data.result;
    } else {
      throw new Error('获取研发机构表失败');
    }
  });
};